import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Contact from "@/components/sections/Contact";
import LeadCapture from "@/components/sections/LeadCapture";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Contact · Pickle Wall™";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" className="bg-[#0a0a0a] text-white min-h-screen pt-20">
      <Navbar />
      <Contact />
      <LeadCapture />
      <Footer />
    </main>
  );
}
